const _jsxFileName = '';
import React from 'react';

const VideoSection = ({ onNavigate }) => {
  return React.createElement(
    'section',
    {
      className: 'relative h-[60vh] w-full overflow-hidden flex items-center justify-center my-12',
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 9 },
    },
    /* Fallback image if video fails to load or for mobile optimization */
    React.createElement(
      'div',
      {
        className: 'absolute inset-0 bg-stone-900',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 11 },
      },
      React.createElement('img', {
        src: 'https://images.unsplash.com/photo-1629224316810-9d8805b95e76?q=80&w=2070&auto=format&fit=crop',
        className: 'w-full h-full object-cover opacity-50',
        alt: 'Jewelry making',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 12 },
      })
    ),

    /* Dark Overlay */
    React.createElement('div', {
      className: 'absolute inset-0 bg-black/60 z-10',
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 20 },
    }),

    React.createElement(
      'div',
      {
        className: 'relative z-20 text-center px-6',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 22 },
      },
      React.createElement(
        'h2',
        {
          className: 'text-shimmer font-serif text-3xl md:text-5xl mb-6',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 23 },
        },
        'The Art of Brilliance'
      ),
      React.createElement(
        'p',
        {
          className: 'text-gray-300 max-w-2xl mx-auto font-light leading-relaxed mb-8',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 26 },
        },
        'Every gemstone is selected for its exceptional clarity and color. Our master artisans handcraft each setting, ensuring that your piece is as unique as the moment it celebrates.'
      ),
      React.createElement(
        'button',
        {
          onClick: () => onNavigate('shop'),
          className:
            'px-6 py-3 border border-gold-500 text-gold-400 hover:bg-gold-500 hover:text-white transition-all duration-300 text-xs tracking-widest uppercase',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 29 },
        },
        'Discover Our Atelier'
      )
    )
  );
};

export default VideoSection;
